import axios from "axios";
import { API } from "../axios/API";
import { deudasService } from "./deudas.service";
import Swal from "sweetalert2";

export const actuacionesService = {
  async getActuaciones(data) {
    try {
      const response = await axios.post("https://wsrfa.sannicolasciudad.gob.ar/cobrojud/listaEtapas.php", { data });

      if (response.data?.mensaje) return response.data?.mensaje;

      return response?.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },

  async getActuacionDocumento(id) {
    try {
      const response = await API.get(`/actuacion-documento/${id}`);

      return response?.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },

  async actuacionesxImp(data) {
    try {
      const response = await API.post("/actuaciones/actuacionesxImp", data);

      return response?.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },

  async actuacionesxAbogado(data) {
    try {
      const response = await API.post("/actuaciones/getByAbogado", data);

      return response?.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },

  async actuacionesTrimestrales(data) {
    try {
      const response = await API.post("/actuaciones/trimestral", data);

      return response?.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },

  async searchActuaciones(data) {
    try {
      const response = await API.post("/actuaciones/search", data);

      return response?.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },

  async actuacionesSearch({ data, abogado, grupo, desde, hasta, gruposId, user }, type) {
    let body = {
      bsq: 1,
      abogado
    };

    if (data?.nro_imponible) {
      body.imponible = data.nro_imponible;
    }
    if (data?.recurso) {
      body.recurso = data.recurso;
    }
    if (data?.dni) {
      body.dni = data.dni;
    }
    if (data?.nombre) {
      body.nombre = data.nombre;
    }
    if (data?.calle && data?.altura) {
      body.calle = data.calle;
      body.altura = data.altura;
    }

    if (data?.nro_imponible && !data?.recurso) {
      return Swal.fire(
        "Debe ingresar un recurso.",
        "",
        "warning"
      );
    }

    const situaciones = await deudasService.listaSitua(body).then(res => res.situacion);

    let actuacionesRes = [];

    if (type === "extrajudicial") {
      const judiciales = await this.actuacionesTrimestrales({
        abogado,
        grupo: 3,
        desde,
        imponible: data?.nro_imponible || "",
        recurso: data?.recurso || "",
        user
      });
      const extrajudiciales = await this.actuacionesTrimestrales({
        abogado,
        grupo: 2,
        desde,
        imponible: data?.nro_imponible || "",
        recurso: data?.recurso || "",
        user
      });

      if (judiciales?.length) {
        actuacionesRes = [...actuacionesRes, ...judiciales];
      }
      if (extrajudiciales?.length) {
        actuacionesRes = [...actuacionesRes, ...extrajudiciales];
      }
    } else if (type === "judicial") {
      try {
        actuacionesRes = await this.actuacionesTrimestrales({
          abogado,
          grupo,
          desde,
          imponible: data?.nro_imponible || "",
          recurso: data?.recurso || "",
          user
        });
      }
      catch (err) {
        actuacionesRes = [];
      }
    }
    else {
      try {
        actuacionesRes = await this.actuacionesTrimestrales({
          abogado,
          gruposId,
          desde,
          hasta,
          imponible: data?.nro_imponible || "",
          recurso: data?.recurso || "",
          user
        });
      }
      catch (err) {
        actuacionesRes = [];
      }
    }

    // const addFecha = await configuracionService.getConfiguracion({ key: "ADD_FECHA" }).then((res) => res.value);
    return this.actuacionesFormat({
      contribuyentes: situaciones,
      actuacionesRes,
      situaciones,
      abogado,
      // addFecha
    });
  },

  async recursosxImp({ tipo = "", imponible = "" }) {
    const res = await axios.get(`https://wsrfa.sannicolasciudad.gob.ar/consultas/recursosxImp.php?tipo=${tipo}&imponible=${imponible}`);

    return res.data;
  },

  async actuacionesFormat({ contribuyentes, actuacionesRes, situaciones, abogado, addFecha }) {
    if (contribuyentes && Array.isArray(contribuyentes) && contribuyentes?.length) {
      let result = contribuyentes.reduce((prev, current) => {

        if (prev?.length) {
          let some = prev?.some(p => p?.apellnom === current?.CONTRIBUYENTE?.APYNOM);

          if (some) {
            return prev;
          } else {
            let filtered = contribuyentes.filter((e) => e?.CONTRIBUYENTE?.APYNOM === current?.CONTRIBUYENTE?.APYNOM);

            const imponibles = filtered.reduce((prev, current) => {
              let actuaciones = actuacionesRes?.length ? actuacionesRes.filter((ac) => +ac.imponible === +current.NRO_IMPONIBLE) : [];
              let historicosArray = situaciones?.filter((s) => s?.NRO_IMPONIBLE === current?.NRO_IMPONIBLE);

              return this.actuacionFormat({
                current,
                prev,
                actuaciones,
                historicosArray,
                addFecha
              });
            }, []);

            return [
              ...prev,
              {
                apellnom: current?.CONTRIBUYENTE?.APYNOM,
                NRO_CONTRIB: current?.CONTRIBUYENTE?.NRO_CONTRIB,
                IMPONIBLE: current?.NRO_IMPONIBLE,
                RECURSO: current?.RECURSO,
                imponibles,
                abogado
              },
            ];
          }
        } else {
          let filtered = contribuyentes.filter((e) => e?.CONTRIBUYENTE?.APYNOM === current?.CONTRIBUYENTE?.APYNOM);
          const imponibles = filtered.reduce((prev, current) => {
            let actuaciones = actuacionesRes?.length ? actuacionesRes.filter((ac) => +ac.imponible === +current.NRO_IMPONIBLE) : [];
            let historicosArray = situaciones?.filter((s) => s?.NRO_IMPONIBLE === current?.NRO_IMPONIBLE);

            return this.actuacionFormat({
              current,
              prev,
              actuaciones,
              historicosArray,
              addFecha
            });
          }, []);

          return [
            {
              apellnom: current?.CONTRIBUYENTE?.APYNOM,
              NRO_CONTRIB: current?.CONTRIBUYENTE?.NRO_CONTRIB,
              IMPONIBLE: current?.NRO_IMPONIBLE,
              RECURSO: current?.RECURSO,
              imponibles,
              abogado
            },
          ];
        }
      }, []);

      return result;
    }
    else {
      return [];
    }
  },

  actuacionFormat({
    current,
    prev,
    actuaciones,
    historicosArray,
    // addFecha
  }) {
    try {
      let inmueblesHistoricos = historicosArray;

      if (inmueblesHistoricos?.length) {
        inmueblesHistoricos = [...inmueblesHistoricos].sort((a, b) => {
          if (a.FECHA && b.FECHA) {
            const [day, month, year] = a.FECHA.split("/");
            const [day2, month2, year2] = b.FECHA.split("/");

            return new Date(`${year}-${month}-${day}`) - new Date(`${year2}-${month2}-${day2}`);
          } else {
            return -1;
          }
        });
      }

      let historico = null;

      if (inmueblesHistoricos?.length) {
        historico = inmueblesHistoricos[inmueblesHistoricos.length - 1];
      }

      if (historico?.FECHA) {
        const [day_current, month_current, year_current] = historico.FECHA.split("/");
        const fecha = year_current + "-" + month_current + "-" + day_current;

        historico = {
          ...historico,
          fecha,
          titulo: inmueblesHistoricos?.some(h => h?.SITUACION === "Título Ejecutivo"),
          IMPONIBLE: historico.NRO_IMPONIBLE
        };
      }

      return [
        ...prev,
        {
          ...current,
          IMPONIBLE: current.NRO_IMPONIBLE,
          actuaciones,
          historico
        }
      ];
    } catch (err) {
      console.log(err);
      return prev;
    }
  },

  async lastActuacion(data) {
    try {
      const response = await API.post("/actuaciones/last", data);

      return response?.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },

  async listaTitEjecutivos(data) {
    try {
      const response = await axios.post("https://wsrfa.sannicolasciudad.gob.ar/cobrojud/listaTitEjecutivos.php", data);

      return response?.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },

  async getDatosCargados(id) {
    try {
      const response = await API.get(`/actuaciones/datos-cargados/${id}`);

      return response?.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },

  async checkRadicacion(data) {
    try {
      const response = await API.post("/actuaciones/check-radicacion", data);

      return response?.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },

  async getRadicacion(data) {
    try {
      const response = await API.post("/actuaciones/buscar-radicacion", data);

      return response?.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
};